document.addEventListener("DOMContentLoaded", function () {
 const header = document.querySelector(".header");
const main = document.querySelector("main");

if (!header || !main) return;

const firstSection = main.querySelector(".shopify-section:first-child");
if (!firstSection) return;

let isAtTop = null;
let headerClass = "";

if (firstSection.classList.contains("shopify-section--slideshow")) {
  headerClass = "at-top";
} else if (
  firstSection.classList.contains("shopify-section--rich-text") 
  
) {
  // 👇 aquí agregamos la condición extra
  const next = firstSection.nextElementSibling;
  if (!next || !next.classList.contains("shopify-section--main-blog")) {
    headerClass = "at-top-transparent";
  } else {
    return; // salimos si después viene el blog
  }
} else {
  return;
}

const checkScroll = () => {
  const atTop = window.scrollY === 0;

  if (atTop !== isAtTop) {
    header.classList.toggle(headerClass, atTop);
    isAtTop = atTop;
  }
};

checkScroll();
window.addEventListener("scroll", checkScroll, { passive: true });


  /* floag-buttom */
  const floatingBtn = document.querySelector(".floag-button-slideshow");
  if (!floatingBtn) return;

  function updatePosition() {
    if (window.scrollY > 0) {
      const rect = floatingBtn.getBoundingClientRect();
      floatingBtn.style.position = "fixed";
      floatingBtn.style.top = `${rect.top}px`;
      floatingBtn.style.left = `${rect.left}px`;
    } else {
      floatingBtn.style.position = "absolute";
      floatingBtn.style.top = "";
      floatingBtn.style.left = "";
    }
  }

  // Scroll normal
  window.addEventListener("scroll", updatePosition);

  // Al recargar la página, solo cambiamos position sin top/left
  window.addEventListener("load", function () {
    if (window.scrollY > 0) {
      console.log('se recargo la pagina')
      floatingBtn.style.position = "fixed";
      floatingBtn.style.top = "";
      floatingBtn.style.left = "";
    } else {
      floatingBtn.style.position = "absolute";
    }
  });
})



